import { ApiClient, ApiClientProps } from './client';

export type IntegrationStatus = {
  connected: boolean;
  stale?: boolean;
  connected_by?: {
    name: string;
    email: string;
  };
  connected_at?: string;
  trimble_user_email?: string;
};

export type AuthorizeResponse = {
  authorization_url: string;
};

export type DirectorySyncStatus = {
  enabled: boolean;
  connected: boolean;
  setup_pending: boolean;
  last_synced_at: string | null;
  managed_user_count: number;
};

export type DirectorySyncSetupResponse = {
  setup_url: string;
};

export type AccubidDatabase = {
  Token: string;
  DatabaseName: string;
};

export type AccubidProject = {
  ProjectID: string;
  ProjectName: string;
  ProjectNumber: string;
};

export type AccubidEstimate = {
  EstimateID: string;
  EstimateName: string;
  EstimateNumber: string;
  Status: string;
  Contract: string | null;
  CreatedDate: string;
};

export type AccubidCloseoutPreview = {
  available: boolean;
  has_bid_breakdown: boolean;
  selling_price?: string;
  bid_summary_name?: string;
  buckets?: Record<string, { amount: string; percent: string }>;
  key_indicators?: Record<string, unknown>;
};

export class IntegrationsClient extends ApiClient {
  constructor(props: ApiClientProps) {
    super(props);
  }

  getAccubidStatus = async () => {
    return this._get<IntegrationStatus>('integrations/accubid/status/');
  };

  getAccubidAuthorizeUrl = async () => {
    return this._get<AuthorizeResponse>('integrations/accubid/authorize/');
  };

  disconnectAccubid = async () => {
    return this._post<void>('integrations/accubid/disconnect/');
  };

  getDirectorySyncStatus = async () => {
    return this._get<DirectorySyncStatus>('integrations/directory-sync/status/');
  };

  startDirectorySyncSetup = async () => {
    return this._post<DirectorySyncSetupResponse>('integrations/directory-sync/setup/');
  };

  getAccubidDatabases = async () => {
    return this._get<{ databases: AccubidDatabase[] }>('integrations/accubid/databases/');
  };

  getAccubidProjects = async (databaseToken: string) => {
    return this._get<{ projects: AccubidProject[] }>(
      `integrations/accubid/databases/${encodeURIComponent(databaseToken)}/projects/`,
    );
  };

  getAccubidEstimates = async (databaseToken: string, projectId: string) => {
    return this._get<{ estimates: AccubidEstimate[] }>(
      `integrations/accubid/databases/${encodeURIComponent(databaseToken)}/projects/${encodeURIComponent(projectId)}/estimates/`,
    );
  };

  getAccubidCloseoutPreview = async (databaseToken: string, estimateId: string) => {
    return this._get<AccubidCloseoutPreview>('integrations/accubid/closeout-preview/', {
      database_token: databaseToken,
      estimate_id: estimateId,
    });
  };
}
